import type { DatasetCardWrapperProps } from "./dataset-card.type";

import { DatasetCard } from "./dataset-card.component";

export const DatasetCardWrapper = ({
  template,
  ...props
}: DatasetCardWrapperProps) => {
  if (!template) return null;

  return <DatasetCard {...props} template={template} />;
};
